import { Component, inject } from '@angular/core';
import { LucideDynamicIcon, LucideMoon, LucideSun, provideLucideIcons } from '@lucide/angular';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'ui-theme-toggle',
  standalone: true,
  imports: [LucideDynamicIcon],
  providers: [provideLucideIcons(LucideSun, LucideMoon)],
  template: `
    <button
      type="button"
      class="ui-theme-toggle"
      (click)="theme.toggle()"
      [attr.aria-label]="theme.mode() === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'"
      [attr.title]="theme.mode() === 'dark' ? 'Tema claro' : 'Tema escuro'"
    >
      @if (theme.mode() === 'dark') {
        <svg lucideIcon="sun" [size]="18"></svg>
      } @else {
        <svg lucideIcon="moon" [size]="18"></svg>
      }
    </button>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      align-self: center;
    }

    .ui-theme-toggle {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 2.25rem;
      height: 2.25rem;
      border: 1px solid var(--border-color, #e8e8e8);
      border-radius: 0.5rem;
      background: var(--surface-bg, #fff);
      color: var(--text-primary, #1f1f1f);
      cursor: pointer;
      transition: background 0.15s, border-color 0.15s, color 0.15s;
    }

    .ui-theme-toggle:hover {
      background: var(--surface-muted, #f5f5f5);
      border-color: color-mix(in srgb, var(--border-color, #e8e8e8) 70%, var(--text-primary, #1f1f1f));
    }

    .ui-theme-toggle svg {
      stroke: currentColor;
    }

    :host-context(.ui-topbar--primary) .ui-theme-toggle {
      border-color: var(--topbar-border, var(--on-brand-primary-border));
      background: var(--topbar-surface, var(--on-brand-primary-subtle));
      color: var(--topbar-fg, var(--on-brand-primary));
    }

    :host-context(.ui-topbar--primary) .ui-theme-toggle:hover {
      background: var(--topbar-surface-hover, var(--on-brand-primary-hover));
      border-color: var(--topbar-border, var(--on-brand-primary-border));
    }
  `],
})
export class UiThemeToggleComponent {
  theme = inject(ThemeService);
}
